import { sizeDpr } from "@/utils/sizeDpr";
import Phaser from "phaser";
import CameraControllerPlugin from "phaser4-rex-plugins/plugins/cameracontroller-plugin.js";
import MainMapScene from "./MainMapScene";

// Pridaj tento riadok na definovanie globálnej premennej
// Fix pre dojebabrany kod od Phaseristov
window.Phaser = Phaser;

export const createPhaserGame = (container: HTMLDivElement): Phaser.Game => {
	if (!container) throw new Error("Container not found");

	const width: number = window.innerWidth;
	const height: number = window.innerHeight;

	return new Phaser.Game({
		type: Phaser.WEBGL,
		width: width,
		height: height,
		parent: container,
		scene: [MainMapScene],
		dom: {
			createContainer: true,
		},
		transparent: true,
		render: {
			antialias: false,
			antialiasGL: false,
			powerPreference: "default",
			roundPixels: false,
			mipmapFilter: "NEAREST",
		},
		scale: {
			mode: Phaser.Scale.FIT,
			parent: container,
			width: sizeDpr().width,
			height: sizeDpr().height,
			autoCenter: Phaser.Scale.CENTER_BOTH,
		},
		plugins: {
			global: [
				{
					key: "rexCameraController",
					plugin: CameraControllerPlugin,
					start: true,
				},
			],
		},
	});
};
